import { AdminApiRoutes } from '@gr/core/admin-api-routes';
import type { ParamValue } from '@gr/core/platform/config/registry';
import type { PlatformSettingsDto, SaveSettingResultDto } from '@gr/core/platform/config/dto';
import type { OperationResult } from '@gr/utils/operation-result';
import type { HttpClient } from '../../../shared/http/http-client';

export class ConfigApi {
  constructor(private readonly http: HttpClient) {}

  // CFG-UC-2
  settings(): Promise<OperationResult<PlatformSettingsDto>> {
    return this.http.get(AdminApiRoutes.settings.list);
  }
  saveSetting(key: string, value: ParamValue): Promise<OperationResult<SaveSettingResultDto>> {
    return this.http.put(AdminApiRoutes.settings.byKey(key), { value });
  }
  resetSetting(key: string): Promise<OperationResult<SaveSettingResultDto>> {
    return this.http.delete(AdminApiRoutes.settings.byKey(key));
  }
}
